import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';

const testimonials = [
  {
    id: 1,
    quote: "I worked closely with Divy Kairoth in my Founder's Office, and later watched him grow quickly as a Product Manager. What stood out most was his risk appetite and willingness to take on unclear, high-ownership work without waiting for direction. He moves fast, communicates clearly, and handles both internal teams and clients with maturity. He's comfortable in chaos, thinks independently, and consistently steps up when things get messy.",
    highlight: "If you're a founder looking for someone who brings energy, responsibility, and a real 0\u21921 mindset, I'd strongly recommend him!",
    name: 'Ishmeet Singh Anand',
    role: 'Founder & CEO',
    company: 'Infinite Locus',
    relationship: 'Managed Divy directly',
    linkedin: 'https://www.linkedin.com/in/ishmeet-singh-anand-ba598118/',
    image: '/images/ishmeet.png',
  },
];

const Testimonials = () => {
  return (
    <section
      className="relative py-24 px-6"
      style={{ background: 'white', zIndex: 50 }}
    >
      <div className="max-w-5xl mx-auto">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-16 text-center"
        >
          <p
            className="text-sm font-medium tracking-wide uppercase mb-4"
            style={{ color: 'var(--accent-orange)' }}
          >
            What People Say
          </p>
          <h2 className="text-5xl md:text-6xl font-bold mb-6">
            <span style={{ color: '#122F26' }}>Kind </span>
            <span
              style={{
                background: 'linear-gradient(to right, var(--accent-green), var(--accent-orange))',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              Words
            </span>
          </h2>
        </motion.div>

        {/* Testimonial Cards */}
        {testimonials.map((testimonial) => (
          <motion.div
            key={testimonial.id}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div
              className="p-10 md:p-14 rounded-[2.5rem] relative overflow-hidden"
              style={{
                background: '#122F26',
              }}
            >
              {/* Quote Icon */}
              <div
                className="absolute top-8 right-8 opacity-10"
              >
                <Quote size={120} style={{ color: 'var(--accent-green)' }} />
              </div>

              {/* Quote Text */}
              <div className="relative z-10 space-y-6">
                <p
                  className="text-lg md:text-xl leading-relaxed"
                  style={{ color: 'var(--text-on-dark)', opacity: 0.9 }}
                >
                  "{testimonial.quote}"
                </p>

                {testimonial.highlight && (
                  <p
                    className="text-xl md:text-2xl font-bold leading-relaxed"
                    style={{ color: 'var(--accent-green)' }}
                  >
                    "{testimonial.highlight}"
                  </p>
                )}

                {/* Author */}
                <div className="flex items-center space-x-4 pt-6 border-t" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
                  {testimonial.image ? (
                    <img src={testimonial.image} alt={testimonial.name} className="w-14 h-14 rounded-full object-cover" />
                  ) : (
                    <div
                      className="w-14 h-14 rounded-full flex items-center justify-center font-bold text-lg"
                      style={{ background: 'var(--accent-orange)', color: 'var(--bg-dark)' }}
                    >
                      {testimonial.name.split(' ').map(n => n[0]).join('')}
                    </div>
                  )}
                  <div>
                    <a
                      href={testimonial.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-lg font-bold hover:underline"
                      style={{ color: 'var(--text-on-dark)' }}
                    >
                      {testimonial.name}
                    </a>
                    <p
                      className="text-sm"
                      style={{ color: 'var(--accent-green)' }}
                    >
                      {testimonial.role}, {testimonial.company}
                    </p>
                    <p
                      className="text-xs mt-1"
                      style={{ color: 'var(--text-on-dark)', opacity: 0.5 }}
                    >
                      {testimonial.relationship}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
